import { ScreenId } from "@/js/value-objects/screen-id";
export class EvacuationOrderScreenMode {
  // 新規作成
  static CREATE = "emergency-mail-create";
  // 編集
  static EDIT = "emergency-mail-edit";
  // 参照
  static VIEW = "emergency-mail-view";
  // コピーして編集
  static DUPLICATE = "emergency-mail-duplicate";

  /**
   * コンストラクタ
   * @param {*} value Routerのname属性
   */
  constructor(value) {
    this.value = value;
  }
  /**
   * インスタンス生成
   * @param {*} value Routerのname属性
   * @returns EvacuationOrderScreenModeインスタンス
   */
  static factory(value) {
    return new EvacuationOrderScreenMode(value);
  }
  /**
   * モード判定（新規作成）
   * @returns true：「新規作成」モード、false：「新規作成」モード以外
   */
  isCreate() {
    return this.value === EvacuationOrderScreenMode.CREATE;
  }
  /**
   * モード判定（編集）
   * @returns true：「編集」モード、false：「編集」モード以外
   */
  isEdit() {
    return this.value === EvacuationOrderScreenMode.EDIT;
  }
  /**
   * モード判定（参照）
   * @returns true：「参照」モード、false：「参照」モード以外
   */
  isView() {
    return this.value === EvacuationOrderScreenMode.VIEW;
  }
  /**
   * モード判定（コピーして編集）
   * @returns true：「コピーして編集」モード、false：「コピーして編集」モード以外
   */
  isDuplicate() {
    return this.value === EvacuationOrderScreenMode.DUPLICATE;
  }
  /**
   * 画面ID取得
   * @returns 画面ID
   */
  getScreenId() {
    let screenId = "";
    switch (this.value) {
      case EvacuationOrderScreenMode.CREATE:
        // 新規登録
        screenId = ScreenId.SF0308;
        break;
      case EvacuationOrderScreenMode.EDIT:
        // 編集
        screenId = ScreenId.SF0308;
        break;
      case EvacuationOrderScreenMode.VIEW:
        // 参照
        screenId = ScreenId.SF0306;
        break;
      case EvacuationOrderScreenMode.DUPLICATE:
        // コピーして編集
        screenId = ScreenId.SF0308;
        break;
      default:
        break;
    }
    return screenId;
  }
}
